import src from "IMAGE";
export default { src, width: 200, height: 50, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/AAAAAABqdHCFpci5/8je1P+41Mj/xdzS/2lwbXoAAAAAAAAAAABwdXCFwcy8/8jd0//L4Nf/1ebe/29zcXoAAAAAY3Midtg/O9gAAAAASUVORK5CYII="};
